var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Provider = require('./provider');

var Manager = require('./manager');

var Murmur =
/*#__PURE__*/
function () {
  "use strict";

  function Murmur(options) {
    _classCallCheck(this, Murmur);

    this.isBridge = options.isBridge;
    this.protocols = options.protocols || [];
    this.signalServers = options.signalServers || [];
    this.ignoreBloomFilters = options.ignoreBloomFilters !== undefined ? options.ignoreBloomFilters : false;
    this.bootnodes = options.bootnodes || [];
    this.nodes = [];

    if (this.protocols.length != 2) {
      this.isBridge = false;
    }

    this.provider = new Provider();
    this.manager = new Manager(this.provider, {
      isBridge: this.isBridge,
      ignoreBloomFilters: this.ignoreBloomFilters
    });
  }

  _createClass(Murmur, [{
    key: "onReady",
    value: function onReady(cb) {
      this.manager.executeOnReady(cb);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var devp2p, LibP2PNode, libp2p;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.protocols.indexOf("devp2p") > -1) {
                  devp2p = require("./devp2p-node.js");
                  devp2p.start();
                  devp2p.connectTo({
                    address: '127.0.0.1',
                    udpPort: 30303,
                    tcpPort: 30303
                  });
                  this.nodes.push(devp2p);
                }

                if (this.protocols.indexOf("libp2p") > -1) {
                  LibP2PNode = require('./libp2p-node.js');
                  libp2p = new LibP2PNode({
                    isBrowser: typeof window !== 'undefined',
                    bootnodes: this.bootnodes,
                    signalServers: this.signalServers
                  });
                  libp2p.start();
                  this.nodes.push(libp2p);
                }

                this.manager.setupNodes(this.nodes);
                this.manager.start(this.readyCB);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return Murmur;
}();

module.exports = Murmur;